export default "__VITE_ASSET__UC0ahx$R__"